import React, { useEffect, useState } from 'react'
import ProtectedRoute from '../../middleware/ProtectedRoute'
import PublicHeader from '../../components/ui/PublicHeader'
import { useNavigate } from 'react-router-dom'
import classes from './Checkout.module.css'
import { Box, Container, Text, Accordion, Group, Divider, TextInput, Flex, Button, Select, Textarea, Input } from '@mantine/core'
import { IconArrowNarrowLeft } from '@tabler/icons-react'
import CheckoutSession from '../../components/pages/Checkout/CheckoutSession'
import { useSelector } from 'react-redux'
import { getProvinces, getCities } from '../../services/address'
import { getProfileUser, updateProfilebyUser } from '../../services/user'
import { IMaskInput } from 'react-imask'
import { IconUserCheck } from '@tabler/icons-react'
import PaymentSession from '../../components/pages/Checkout/PaymentSession'
import VoucherSession from '../../components/pages/Checkout/VoucherSession'
import DetailPaymentSession from '../../components/pages/Checkout/DetailpaymentSession'
import { formatPrice } from '../../plugins/formatPrice'
import { validation } from '../../plugins/validation'
import { notificationSuccess, notificationError } from '../../components/ui/Notification'
import { confirmPayment } from '../../services/transaction'

const defaultVal = {
  phone: '',
  status: 'pelajar',
  job: '',
  company: '',
  institution: '',
  department: '',
  desiredJobSector: null,
  desiredJob: null,
  linkedin: '',
  email: '',
  fullName: '',
  nickname: '',
  address: '',
  countryId: '',
  provinceId: '',
  cityId: '',
  graduationYear: null,
  entryYear: null
}

const formValidation = {
  fullName: {
    isError: false,
    message: ''
  },
  nickname: {
    isError: false,
    message: ''
  },
  linkedin: {
    isError: false,
    message: ''
  },
  desiredJob: {
    isError: false,
    message: ''
  },
  desiredJobSector: {
    isError: false,
    message: ''
  },
  department: {
    isError: false,
    message: ''
  },
  institution: {
    isError: false,
    message: ''
  },
  company: {
    isError: false,
    message: ''
  },
  job: {
    isError: false,
    message: ''
  },
  status: {
    isError: false,
    message: ''
  },
  phone: {
    isError: false,
    message: ''
  },
  address: {
    isError: false,
    message: ''
  },
  countryId: {
    isError: false,
    message: ''
  },
  provinceId: {
    isError: false,
    message: ''
  },
  cityId: {
    isError: false,
    message: ''
  },
  graduationYear: {
    isError: false,
    message: ''
  },
  entryYear: {
    isError: false,
    message: ''
  }
}

const dataStatus = [
  {
    value: 'pelajar',
    label: 'Pelajar'
  },
  {
    value: 'bekerja',
    label: 'Bekerja'
  },
  {
    value: 'tidak_bekerja',
    label: 'Belum Bekerja'
  },
]

const Checkout = () => {
  const navigate = useNavigate()
  const [ formData, setFormData ] = useState(defaultVal)
  const [ validationForm, setValidationForm ] = useState(formValidation)
  const [ loadingSubmit, setLoadingSubmit ] = useState(false)
  const cartItems = useSelector(state => state.checkout.cart)
  const loginData = useSelector(state => state.member.data)
  const [ dataCountries, setDataCountries ] = useState([])
  const [ dataProvinces, setDataProvinces ] = useState([])
  const [ dataCities, setDataCities ] = useState([])
  const [selectedCountry, setSelectedCountry] = useState('')
  const [selectedProvince, setSelectedProvince] = useState('')
  const [selectedCity, setSelectedCity] = useState('')
  const [selectedStatus, setSelectedStatus] = useState('pelajar')

  const handleProfileUser = async (userId) => {
    try {
      const response = await getProfileUser(userId)
      const dataResponse = Object.keys(response)
      if (dataResponse.length > 0) {
        const responseData = {
          fullName: response.fullName ? response.fullName : '',
          nickname: response.nickname ? response.nickname : '',
          email: response.email ? response.email : '',
          phone: response.phone ? response.phone : '',
          status: response.status ? response.status : '',
          job: response.job ? response.job : '',
          company: response.company ? response.company : '',
          institution: response.institution ? response.institution : '',
          department: response.department ? response.department : '',
          desiredJobSector: response.desiredJobSector ? response.desiredJobSector : '',
          desiredJob: response.desiredJob ? response.desiredJob : '',
          linkedin: response.linkedin ? response.linkedin : '',
          address: response.address ? response.address : '',
          countryId: response.country ? response.country.id: '',
          provinceId: response.province ? response.province.id : '',
          cityId: response.city ? response.city.id : '',
          graduationYear: response.graduationYear ? response.graduationYear : null,
          entryYear: response.entryYear ? response.entryYear : null
        }
        setFormData(responseData)
        setSelectedCountry(response.country ? response.country.id.toString(): '1')
        setSelectedProvince(response.province ? response.province.id.toString() : '')
        setSelectedCity(response.city ? response.city.id.toString() : '')
        setSelectedStatus(response.status ? response.status : 'pelajar')
      } else {
        const data = {
          fullName: loginData.fullName,
          email: loginData.email,
          phone: '',
          status: 'pelajar',
          job: '',
          company: '',
          institution: '',
          department: '',
          desiredJobSector: null,
          desiredJob: null,
          linkedin: '',
          address: '',
          countryId: '',
          provinceId: '',
          cityId: '',
          graduationYear: null,
          entryYear: null
        }
        setFormData(data)
        setSelectedCountry('')
        setSelectedProvince('')
        setSelectedCity('')
        setSelectedStatus('pelajar')
      }
    } catch (error) {
      console.log(error)
    }
  }

  const submitCheckout = async (payloadProfile) => {
    setLoadingSubmit(true)
    setValidationForm(formValidation)
    const payload = {
      fullName: payloadProfile.fullName,
      phone: payloadProfile.phone,
      email: payloadProfile.email,
      address: payloadProfile.address,
      linkedin: payloadProfile.linkedin,
      status: selectedStatus,
      countryId: '1',
      provinceId: selectedProvince,
      cityId: selectedCity
    }
    if (selectedStatus === 'pelajar') {
      payload.institution = payloadProfile.institution
      payload.entryYear = payloadProfile.entryYear
      payload.department = payloadProfile.department
    } else if (selectedStatus === 'bekerja') {
      payload.job = payloadProfile.job
      payload.company = payloadProfile.company
      payload.graduationYear = payloadProfile.graduationYear
    } else if (selectedStatus === 'tidak_bekerja') {
      payload.institution = payloadProfile.institution
      payload.department = payloadProfile.department
      payload.desiredJobSector = payloadProfile.desiredJobSector
      payload.desiredJob = payloadProfile.desiredJob
      payload.graduationYear = payloadProfile.graduationYear
    }
    const isError = validation(payload, setValidationForm)
    if (isError) {
      setLoadingSubmit(false)
      return 
    }
    payload.countryId = Number(selectedCountry)
    payload.provinceId = Number(selectedProvince)
    payload.cityId = Number(selectedCity)
    try {
      const response = await updateProfilebyUser(loginData.id, payload)
      console.log(response)
      if (response) {
        submitPayment()
      }
    } catch (error) {
      setLoadingSubmit(false)
      const errorMessage = error?.response?.data?.message
      
      let notificationMsg = 'Silahkan periksa kembali form anda';
      if (typeof errorMessage === 'string') {
        notificationMsg = errorMessage;
      } else if (Array.isArray(errorMessage)) {
        notificationMsg = errorMessage[0]; // Display the first error if it's an array
      }

      notificationError('Checkout Gagal', notificationMsg)

      if (errorMessage && typeof errorMessage === 'object') {
        Object.values(errorMessage).forEach((el) => {
          Object.keys(formValidation).forEach((element) => {
            if (typeof el === 'string' && el.includes(element)) {
              setValidationForm((old) => ({
                ...old,
                [element]: {
                  ...old?.[element],
                  isError: true,
                  message: el
                }
              }))
            }
          })
        })
      }
    }
  }

  const submitPayment = async () => {
    try {
      const response = await confirmPayment(cartItems)
      if (response) {
        notificationSuccess('Transaksi Berhasil', 'Segera untuk melakukan pembayaran')
        navigate(`/transaction/${response.invoiceId}`, { replace: true })
      }
    } catch (error) {
      const errorMessage = error.response.data.message
      console.error(error.response.data.message)
      notificationError('Transaksi Gagal', `${Array.isArray(errorMessage) ? 'Silahkan Pilih Metode Pembayaran' : errorMessage}s`)
    } finally {
      localStorage.removeItem('checkout-data')
      setLoadingSubmit(false)
    }
  }

  const handleGetCountries = () => {
    const dataCountry = [
      {
        value: '1',
        label: 'INDONESIA'
      }
    ]
    setDataCountries(dataCountry)
    setSelectedCountry(dataCountry[0].value)
  }

  const handleGetProvinces = async () => {
    try {
      const response = await getProvinces()
      const provinces = response.data
      const mappingProvinces = provinces.map((val) => {
        return {
          value: val.id.toString(),
          label: val.name
        }
      })
      setDataProvinces(mappingProvinces)
    } catch (error) {
      console.log(error)
    }
  }

  const handleGetCities = async (provinceId) => {
    const params = {
      province: provinceId
    }
    try {
      const response = await getCities(params)
      const cities = response.data
      const mappingCities = cities.map((val) => {
        return {
          value: val.id.toString(),
          label: val.name
        }
      })
      setDataCities(mappingCities)
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (cartItems === null) {
      navigate('/')
    }
    //eslint-disable-next-line
  }, [])

  useEffect(() => {
    if (loginData) {
      handleProfileUser(loginData.id)
    }
    handleGetCountries()
    //eslint-disable-next-line
  }, [loginData])

  useEffect(() => {
    if (formData.countryId !== null || formData.countryId !== undefined || selectedCountry !== null) {
      handleGetProvinces()
    }
    //eslint-disable-next-line
  }, [])

  useEffect(() => {
    if (formData.provinceId !== null || formData.provinceId !== undefined || selectedProvince !== null) {
      handleGetCities(formData.provinceId)
    }
    //eslint-disable-next-line
  }, [])

  const handleChangeForm = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }

  const programPayment = (cart) => {
    if (cart.totalPrice > 0) {
      return (
        <Box>
          <PaymentSession />
          <VoucherSession />
          <DetailPaymentSession />
        </Box>
      )
    }
  }

  const mappingStatusForm = (status) => {
    if (status === 'pelajar') {
      return (
        <Box>
          <TextInput
            name="institution"
            value={formData.institution}
            placeholder="Isi Universitas / Sekolah"
            label="Universitas / Sekolah"
            error={validationForm.institution.isError ? `${validationForm.institution.message}` : ''}
            onChange={handleChangeForm}
            withAsterisk
            mb={10}
          />
          <TextInput
            name="entryYear"
            value={formData.entryYear}
            placeholder="isi tahun masuk"
            label="Tahun Masuk"
            type='number'
            error={validationForm.entryYear.isError ? `${validationForm.entryYear.message}` : ''}
            onChange={handleChangeForm}
            withAsterisk
            mb={10}
          />
          <TextInput
            name="department"
            value={formData.department}
            placeholder="Isi Jurusan"
            label="Jurusan"
            error={validationForm.department.isError ? `${validationForm.department.message}` : ''}
            onChange={handleChangeForm}
            withAsterisk
            mb={10}
          />
        </Box>
      )
    } else if (status === 'bekerja') {
      return (
        <Box>
          <TextInput
            name="graduationYear"
            value={formData.graduationYear}
            placeholder="isi lulus pendidikan"
            label="Tahun Lulus"
            type='number'
            error={validationForm.graduationYear.isError ? `${validationForm.graduationYear.message}` : ''}
            onChange={handleChangeForm}
            withAsterisk
            mb={10}
          />
          <TextInput
            name="job"
            value={formData.job}
            placeholder="Isi Pekerjaan"
            label="Pekerjaan"
            error={validationForm.job.isError ? `${validationForm.job.message}` : ''}
            onChange={handleChangeForm}
            withAsterisk
            mb={10}
          />
          <TextInput
            name="company"
            value={formData.company}
            placeholder="Isi Perusahaan"
            label="Perusahaan"
            error={validationForm.company.isError ? `${validationForm.company.message}` : ''}
            onChange={handleChangeForm}
            withAsterisk
            mb={10}
          />
        </Box>
      )
    } else if (status === 'tidak_bekerja') {
      return (
        <Box>
          <TextInput
            name="institution"
            value={formData.institution}
            placeholder="Isi Universitas / Sekolah"
            label="Universitas / Sekolah"
            error={validationForm.institution.isError ? `${validationForm.institution.message}` : ''}
            onChange={handleChangeForm}
            withAsterisk
            mb={10}
          />
          <TextInput
            name="department"
            value={formData.department}
            placeholder="Isi Jurusan"
            label="Jurusan"
            error={validationForm.department.isError ? `${validationForm.department.message}` : ''}
            onChange={handleChangeForm}
            withAsterisk
            mb={10}
          />
          <TextInput
            name="graduationYear"
            value={formData.graduationYear}
            placeholder="isi lulus pendidikan"
            label="Tahun Lulus"
            type='number'
            error={validationForm.graduationYear.isError ? `${validationForm.graduationYear.message}` : ''}
            onChange={handleChangeForm}
            withAsterisk
            mb={10}
          />
          <TextInput
            name="desiredJobSector"
            value={formData.desiredJobSector}
            placeholder="Isi Pekerjaan yang diinginkan"
            label="Sektor Pekerjaan yang diinginkan"
            error={validationForm.desiredJobSector.isError ? `${validationForm.desiredJobSector.message}` : ''}
            onChange={handleChangeForm}
            withAsterisk
            mb={10}
          />
          <TextInput
            name="desiredJob"
            value={formData.desiredJob}
            placeholder="Isi Pekerjaan yang diinginkan"
            label="Pekerjaan yang diinginkan"
            error={validationForm.desiredJob.isError ? `${validationForm.desiredJob.message}` : ''}
            onChange={handleChangeForm}
            withAsterisk
            mb={10}
          />
        </Box>
      )
    }
  }

  if (cartItems !== null) {
    return (
      <ProtectedRoute>
        <PublicHeader />
        <Box className={classes.checkoutSection}>
          <Container fluid className={classes.section}>
            <Box className={classes.paddingPage}>
              <Box>
                <Button variant="subtle" leftSection={<IconArrowNarrowLeft />} px={0} mb={10} onClick={() => navigate("/")}>Kembali ke Beranda</Button>
                <Text className={classes.titleHeader} fw="bold">Checkout</Text>
              </Box>
              <Box mt={20}>
                <CheckoutSession />
                <Box mb="xl">
                  <Accordion variant="contained" defaultValue="biodataForm">
                    <Accordion.Item value="biodataForm">
                      <Accordion.Control>
                        <Group noWrap>
                          <IconUserCheck color="blue" size="2.5rem" />
                          <Box>
                            <Text className={classes.titleSection} fw="bold">Biodata Member</Text>
                            <Text className={classes.captionSection} c="gray.5" weight={400}>Silahkan cek kembali biodata anda</Text>
                          </Box>
                        </Group>
                      </Accordion.Control>
                      <Accordion.Panel p={8}>
                        <Divider mb="sm" />
                        <Box mb="md">
                          <TextInput
                            name="fullName"
                            value={formData.fullName}
                            placeholder="Isi Nama Lengkap"
                            label="Nama Lengkap"
                            error={validationForm.fullName.isError ? `${validationForm.fullName.message}` : ''}
                            onChange={handleChangeForm}
                            withAsterisk
                            mb={10}
                          />
                          <Input.Wrapper 
                            label="Nomor Hp"
                            error={validationForm.phone.isError ? `${validationForm.phone.message}` : ''}
                            withAsterisk
                            mb={10}
                          >
                            <Input
                              name="phone"
                              value={formData.phone}
                              placeholder="Isi Nomor HP"
                              component={IMaskInput}
                              mask="+6200000000000"
                              onChange={handleChangeForm}
                            />
                          </Input.Wrapper>
                          <TextInput
                            name="email"
                            value={formData.email}
                            label="Email"
                            disabled
                            mb={10}
                          />
                          <Select
                            disabled
                            name="countryId"
                            label="Negara"
                            placeholder="Pilih Negaramu"
                            searchable
                            nothingFound="Tidak Ada Negara"
                            data={dataCountries}
                            mb={10}
                            error={validationForm.countryId.isError ? `${validationForm.countryId.message}` : ''}
                            value={selectedCountry}
                            withAsterisk
                          />
                          <Select
                            disabled={formData.countryId === null || formData.countryId === undefined}
                            name="provinceId"
                            label="Provinsi"
                            placeholder="Pilih Provinsimu"
                            searchable
                            nothingFound="Tidak Ada Provinsi"
                            data={dataProvinces}
                            error={validationForm.provinceId.isError ? `${validationForm.provinceId.message}` : ''}
                            mb={10}
                            onChange={(e) => [setSelectedProvince(e), handleGetCities(Number(e), setSelectedCity(null))]}
                            value={selectedProvince}
                            withAsterisk
                            allowDeselect
                          />
                          <Select
                            disabled={formData.provinceId === null || formData.provinceId === undefined}
                            name="cityId"
                            label="Kota"
                            placeholder="Pilih Kotamu"
                            searchable
                            nothingFound="Tidak Ada Kota"
                            data={dataCities}
                            error={validationForm.cityId.isError ? `${validationForm.cityId.message}` : ''}
                            mb={10}
                            onChange={setSelectedCity}
                            value={selectedCity}
                            withAsterisk
                          />
                          <Textarea
                            name="address"
                            label="Alamat"
                            value={formData.address}
                            placeholder="Isi alamatmu"
                            error={validationForm.address.isError ? `${validationForm.address.message}` : ''}
                            onChange={handleChangeForm}
                            withAsterisk
                            mb={10}
                          />
                          <Input.Wrapper
                            label="URL LinkedIn"
                            error={validationForm.linkedin.isError ? `${validationForm.linkedin.message}` : ''}
                            withAsterisk
                            mb={10}
                          >
                            <Input
                              name="linkedin"
                              value={formData.linkedin}
                              placeholder="Isi URL linked in"
                              leftSection={<Text fz={13} c='gray.7' py={7} px={12} mr={12} bg="gray.1">https://www.</Text>}
                              leftSectionWidth={120}
                              onChange={handleChangeForm}
                            />
                          </Input.Wrapper>
                          <Select
                            name="status"
                            placeholder="pilih status pekerjaan"
                            value={selectedStatus}
                            data={dataStatus}
                            label="Status Pekerjaan"
                            onChange={(e) => setSelectedStatus(e)}
                            mb={10}
                          />
                          {mappingStatusForm(selectedStatus)}
                        </Box>
                      </Accordion.Panel>
                    </Accordion.Item>
                  </Accordion>
                </Box>
                {programPayment(cartItems)}
              </Box>
            </Box>
          </Container>
        </Box>
        <Box className={classes.footerCheckout}>
        <Container fluid className={classes.innerFooter}>
          <Flex align="center" direction={{ base: 'column', md:'row', lg: 'row' }} gap={{ base: 'sm', lg: 'lg' }}>
            <Box>
              <Text>Total Pembayaran</Text>
              <Text className={classes.titleSection} fw="bold" c="green">{formatPrice(cartItems.totalPrice)}</Text>
            </Box>
            <Button loading={loadingSubmit} onClick={() => submitCheckout(formData)}>Bayar Sekarang</Button>
          </Flex>
        </Container>
      </Box>
      </ProtectedRoute>
    )
  }
  
}

export default Checkout